/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Error_Month_ConflictInputs */



/**
* | output |
* | --- |
* | "An invoice already exists for the month this history would be waived under, so it can't be written off there. Reconcile that invoice in Lexware first, or cho..." |
*
* @param {Partner_Admin_Billing_Error_Month_ConflictInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_error_month_conflict = /** @type {((inputs?: Partner_Admin_Billing_Error_Month_ConflictInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Error_Month_ConflictInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den Monat, unter dem diese Historie erlassen würde, existiert bereits eine Rechnung – ein Erlass ist dort deshalb nicht möglich. Bitte diese Rechnung zuerst in Lexware klären oder stattdessen „Aufgelaufene Historie abrechnen“ wählen.")
	return /** @type {LocalizedString} */ ("An invoice already exists for the month this history would be waived under, so it can't be written off there. Reconcile that invoice in Lexware first, or choose “Bill the accumulated history” instead.")
});